/**
 * Roadmap / Timeline Data
 *
 * Milestone based, intentionally flexible.
 * No hard dates, only phases and directional language.
 */

export interface Milestone {
    id: string;
    phase: string;
    title: string;
    description: string;
    status: "completed" | "current" | "upcoming" | "future";
    items: string[];
}

export const roadmapContent = {
    eyebrow: "The Road Ahead",
    headline: "Where We Are and Where We Are Going",
    description:
        "Development is milestone driven, not deadline driven. We ship when things are ready, and we are transparent about the journey.",
};

export const milestones: Milestone[] = [
    {
        id: "foundation",
        phase: "Foundation",
        title: "Core Systems and Prototype",
        description: "Establishing the fundamental gameplay systems and technical foundation.",
        status: "completed",
        items: [
            "Core resource system",
            "Terrain and environment rendering",
            "Caving and underground systems",
            "Early gameplay loop prototype",
        ],
    },
    {
        id: "current",
        phase: "Current Focus",
        title: "Industrial and Planetary Systems",
        description:
            "Building out the industrial expansion pillar and early planetary engineering mechanics.",
        status: "current",
        items: [
            "Manufacturing pipeline depth",
            "Atmospheric simulation layer",
            "Simple planetary terraforming mechanics",
            "Planetary ocean and water systems",
        ],
    },
    {
        id: "demo",
        phase: "Next Milestone",
        title: "Towards Public Demo",
        description:
            "A playable vertical slice that showcases the core vision and lets players experience the mission firsthand.",
        status: "upcoming",
        items: [
            "Polished demo scenario",
            "Onboarding flow",
            "Performance optimisation",
            "First PVE experience"
        ],
    },
    {
        id: "early-access",
        phase: "Planned Direction",
        title: "Towards Early Access",
        description:
            "Expanding all three pillars, deepening systems, and opening up long form gameplay progression.",
        status: "future",
        items: [
            "Full ecological conversion pillar",
            "Advanced planetary engineering",
            "Advcanced planetary terraforming machines",
            "Early access release on Steam",
            "First playable version of the mission",
        ],
    },
    {
        id: "vision",
        phase: "Long Term Vision",
        title: "The Full Mission",
        description:
            "The complete Expedition 744 experience. A deep, interconnected planetary conversion simulation.",
        status: "future",
        items: [
            "Complete three pillar integration",
            "Full terraforming arc",
            "Community driven evolution",
        ],
    },
];
